import OtherSpentRow from './OtherSpentRow'
import messageResource from '../../../messageResource'

const ViewByCPOtherSpentRow = function($containerEl, otherTTInfo)
{
    OtherSpentRow.call(this, $containerEl, otherTTInfo);
};

ViewByCPOtherSpentRow.prototype = _.create(OtherSpentRow.prototype,{
    html: "<tr class='otherSpentRow'>" +
          "  <td class='nameColumn otherTasksTimeTrackText '><div class='subContainer'><%-otherTaskLabel%></div></td>" +
          "  <td class='nameColumn otherProjectsTimeTrackText'><div class='subContainer'><%-otherProjectLabel%></div></td>" +
          "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
          "  <td class='detailsColumn'></td>" +
          "</tr>",

    templateModel: function()
    {
        var baseTemplateModel = this.baseTemplateModel();
        return {
            otherTaskLabel: baseTemplateModel.otherLabel,
            otherProjectLabel:  messageResource.getMessage("view_tt.details_table.other_projects_tt"),
            total: baseTemplateModel.total
        }
    }
});

export default ViewByCPOtherSpentRow



// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/ViewByCPOtherSpentRow.js